<!-- 表格组件封装 -->
<!-- 数据更新时间 -->
<template>
    <div>
        <table-box v-loading="needLoading && tableListInstance.tableLoading" v-bind="$attrs" :version="version" align="center" ref="tableBox" :height="height" :columns="columnsLocal"
            :rows="tableListInstance.totalData" v-on="$listeners">
            <!-- <template v-slot:col-header="{ col }">
                <slot name="col-header" v-bind="{ col }"></slot>
            </template> -->
            <template v-slot:col-append="{ col, row, rIndex }">
                <slot name="col-append" v-bind="{ col, row, rIndex }"></slot>
            </template>
            <template v-slot:nest-table="{ col }">
                <slot name="nest-table" v-bind="{ col }"></slot>
            </template>
        </table-box>
        <lots-pagination v-if="showPagination" class="pagination-custom" @size-change="tableListInstance.sizeChange"
            @current-change="tableListInstance.pageChange" :current-page.sync="tableListInstance.pageNo"
            layout="total, sizes, prev, pager, next, jumper" :total="tableListInstance.pageTotal">
        </lots-pagination>
    </div>
</template>
<script>
import lotsPagination from '@/components/lots/lotsPagination/Index';
import tableBox from '@/components/lots/tableBox/Index';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { watch, computed } from '@vue/composition-api';
import { formatValue } from '@/views/index/config';

export default {
    components: { tableBox, lotsPagination },
    props: {
        height: {
            type: String,
            default: () => ''
        },
        columns: {
            type: Array,
            default: () => []
        },
        params: {
            type: Object,
            default: () => ({})
        },
        beforeRequest: {
            type: Function,
            default: (val = {}) => { return val; }
        },
        afterRequest: {
            type: Function,
            default: null
        },
        showPagination: {
            type: Boolean,
            default: true
        },
        version: {
            type: String,
            default: () => ''
        },
        needLoading: {
            type: Boolean,
            default: false
        },
        nededFormatValue: {
            type: Boolean,
            default: true
        }
    },
    // eslint-disable-next-line max-lines-per-function
    setup(props, setupContext) {
        // 动态创建列表类，支持业务自定义
        class DataDetailClass extends AdvanceListClass {
            beforeGetList(condition) {
                // 执行外部传入的请求前处理函数
                if (props.beforeRequest && typeof props.beforeRequest === 'function') {
                    const result = props.beforeRequest(condition);
                    return { ...condition, ...result };
                }
                return condition;
            }

            // eslint-disable-next-line complexity
            async afterGetList(res) {
                // 执行外部传入的请求后处理函数
                if (props.afterRequest && typeof props.afterRequest === 'function') {
                    const result = await props.afterRequest(res);
                    // 如果有自定义处理，使用自定义结果
                    if (result) {
                        // 给数据的每一项都加入formatValue方法进行格式化
                        this.totalData.value = props.nededFormatValue ? formatValues(result.data) || [] : result.data;
                        this.pageTotal.value = result.total || 0;
                    }
                } else {
                    if (res.data.list) {
                        res.data.list = props.nededFormatValue ? formatValues(res.data.list) || [] : res.data.list;
                    }
                    // 如果不存在自定义，则调用父类方法
                    super.afterGetList(res);
                }
            }
        }

        const tableListInstance = new DataDetailClass({
            Api: {
                listApi: props.params.api
            }
        });
        const isFormatPorpList = computed(() => {
            const _list = columnsLocal.value.filter(it => it.type === 'select');
            return _list.map(it => it.prop);
        });
        const setOtherChildrenProp = (data, key) => {
            if (!data) return false;
            return data.some(it => {
                if (it.children) {
                    // eslint-disable-next-line max-nested-callbacks
                    return it.children.some(el => el.prop === key);
                }
                // 修复：直接返回布尔值
                return it.prop === key;
            });
        };
        const formatValues = (datas) => {
            return datas.map(item => {
                Object.keys(item).forEach(key => {
                    if (!isFormatPorpList.value?.includes(key) && setOtherChildrenProp(columnsLocal.value, key)) {
                        key !== 'angleCode' && (item[key] = formatValue(item[key]));
                    }
                });
                return item;
            });
        };

        const columnsLocal = computed(() => {
            return [...props.columns];
        });

        const getList = () => {
            tableListInstance.totalData.value = [];
            tableListInstance.updateListApi(props.params.api);
            tableListInstance.updateListForeion();
        };

        // 监听入参调用接口
        watch(
            () => props.params,
            (val) => {
                if (val && val.api) {
                    getList();
                } else {
                    console.error('请传入api参数');
                }
            },
            { deep: true }
        );

        return {
            tableListInstance,
            columnsLocal,
            getList
        };
    }
};
</script>
<style lang="less" scoped>
.pagination-custom {
    text-align: right;
    margin-top: 10px;
}
</style>
